import axios from "./axiosInstance";

const galleryAPI = {
  getDetails: (params) => axios.get("assets/list", {params}),
};

export default galleryAPI;
